import React, { useState } from 'react';

/**
 * 表示/非表示を切り替えられるパスワード入力欄。
 *
 * 新規登録やユーザー作成では、入力したパスワードを本人が確認できないと
 * タイプミスに気づけない。特に管理者が従業員のパスワードを代理で決める場面では、
 * 誤入力がそのまま「ログインできない従業員」になって問い合わせを生む。
 *
 * 既存の <input type="password"> をそのまま差し替えられるよう、
 * 見た目と props は素の input に寄せている。
 */
interface PasswordInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** 入力欄本体のスタイル（呼び出し側の既存スタイルをそのまま渡せる） */
  style?: React.CSSProperties;
}

const PasswordInput: React.FC<PasswordInputProps> = ({ style, ...rest }) => {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: 'relative', width: '100%' }}>
      <input
        {...rest}
        type={visible ? 'text' : 'password'}
        style={{
          ...style,
          // ボタンと文字が重ならないよう右側に余白を作る
          paddingRight: '4.5rem',
        }}
      />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? 'パスワードを隠す' : 'パスワードを表示'}
        title={visible ? 'パスワードを隠す' : 'パスワードを表示'}
        style={{
          position: 'absolute',
          top: '50%',
          right: '8px',
          transform: 'translateY(-50%)',
          padding: '2px 6px',
          background: 'transparent',
          border: 'none',
          color: '#2563eb',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer',
          lineHeight: 1.4,
        }}
      >
        {visible ? '隠す' : '表示'}
      </button>
    </div>
  );
};

export default PasswordInput;
